import { Sprite } from 'pixi.js';
export class ComboStarAnim extends Sprite {
    private animated: PIXI.extras.AnimatedSprite;

    constructor(scale: number) {
        super();
        this.alpha = 0;
        const comboFrames = [
            PIXI.utils.TextureCache['fx/combometerVFX0001'],
            PIXI.utils.TextureCache['fx/combometerVFX0002'],
            PIXI.utils.TextureCache['fx/combometerVFX0003'],
            PIXI.utils.TextureCache['fx/combometerVFX0004'],
            PIXI.utils.TextureCache['fx/combometerVFX0005'],
            PIXI.utils.TextureCache['fx/combometerVFX0006'],
            PIXI.utils.TextureCache['fx/combometerVFX0007'],
            PIXI.utils.TextureCache['fx/combometerVFX0008'],
            PIXI.utils.TextureCache['fx/combometerVFX0009'],
            PIXI.utils.TextureCache['fx/combometerVFX0010'],
            PIXI.utils.TextureCache['fx/combometerVFX0011'],
            PIXI.utils.TextureCache['fx/combometerVFX0012'],
            PIXI.utils.TextureCache['fx/combometerVFX0013'],
            PIXI.utils.TextureCache['fx/combometerVFX0014'],
            PIXI.utils.TextureCache['fx/combometerVFX0015'],
        ];

        const anim = new PIXI.extras.AnimatedSprite(comboFrames);
        anim.scale.set(scale);
        anim.anchor.set(0.5);
        this.addChild(anim);

        this.animated = anim;
        this.animated.animationSpeed = 0.5;
        this.animated.loop = false;
    }

    public play() {
        this.alpha = 1;
        this.animated.gotoAndPlay(0);
        this.animated.onComplete = () => {
            this.alpha = 0;
        };
    }
}
